/**
 * Global configuration utility to fetch and manage the API base URL.
 * It reads from /config.xml in the public folder.
 */

const normalizeApiBaseUrl = (url) => {
    if (!url) return url;
    let normalized = url.trim().replace(/\/$/, '');
    if (!normalized.endsWith('/api')) normalized += '/api';
    return normalized;
};

let apiBaseUrl = normalizeApiBaseUrl('http://154.61.75.26:5000'); // Default fallback

export const loadConfig = async () => {
    try {
        const response = await fetch('/config.xml');
        const text = await response.text();
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(text, "text/xml");
        const url = xmlDoc.getElementsByTagName("server_url")[0].childNodes[0].nodeValue;
        if (url) {
            apiBaseUrl = normalizeApiBaseUrl(url);
            console.log("API Base URL loaded from config.xml:", apiBaseUrl);
        }
    } catch (error) {
        console.error("Error loading config.xml, using default:", error);
    }
    return apiBaseUrl;
};

export const getApiUrl = () => apiBaseUrl;
